/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KsosOrderStatisticsInfoVo } from './KsosOrderStatisticsInfoVo';
import {
    KsosOrderStatisticsInfoVoFromJSON,
    KsosOrderStatisticsInfoVoFromJSONTyped,
    KsosOrderStatisticsInfoVoToJSON,
    KsosOrderStatisticsInfoVoToJSONTyped,
} from './KsosOrderStatisticsInfoVo';

/**
 * 
 * @export
 * @interface KoreaStockOutboundOrderSkuStatisticsInfoVo
 */
export interface KoreaStockOutboundOrderSkuStatisticsInfoVo {
    /**
     * sku编码
     * @type {string}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    skuCode?: string;
    /**
     * skuID
     * @type {number}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    skuId?: number;
    /**
     * 图片URL
     * @type {string}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    imageUrl?: string;
    /**
     * 颜色
     * @type {string}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    size?: string;
    /**
     * 名称
     * @type {string}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    name?: string;
    /**
     * 
     * @type {KsosOrderStatisticsInfoVo}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    processingOrderStatisticsInfoVO?: KsosOrderStatisticsInfoVo;
    /**
     * 
     * @type {KsosOrderStatisticsInfoVo}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    outboundOrderStatisticsInfoVO?: KsosOrderStatisticsInfoVo;
    /**
     * 
     * @type {KsosOrderStatisticsInfoVo}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    outboundCancelOrderStatisticsInfoVO?: KsosOrderStatisticsInfoVo;
    /**
     * 
     * @type {KsosOrderStatisticsInfoVo}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    returnOrderStatisticsInfoVO?: KsosOrderStatisticsInfoVo;
    /**
     * 
     * @type {KsosOrderStatisticsInfoVo}
     * @memberof KoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    allOrderStatisticsInfoVO?: KsosOrderStatisticsInfoVo;
}

/**
 * Check if a given object implements the KoreaStockOutboundOrderSkuStatisticsInfoVo interface.
 */
export function instanceOfKoreaStockOutboundOrderSkuStatisticsInfoVo(value: object): value is KoreaStockOutboundOrderSkuStatisticsInfoVo {
    return true;
}

export function KoreaStockOutboundOrderSkuStatisticsInfoVoFromJSON(json: any): KoreaStockOutboundOrderSkuStatisticsInfoVo {
    return KoreaStockOutboundOrderSkuStatisticsInfoVoFromJSONTyped(json, false);
}

export function KoreaStockOutboundOrderSkuStatisticsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaStockOutboundOrderSkuStatisticsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'name': json['name'] == null ? undefined : json['name'],
        'processingOrderStatisticsInfoVO': json['processingOrderStatisticsInfoVO'] == null ? undefined : KsosOrderStatisticsInfoVoFromJSON(json['processingOrderStatisticsInfoVO']),
        'outboundOrderStatisticsInfoVO': json['outboundOrderStatisticsInfoVO'] == null ? undefined : KsosOrderStatisticsInfoVoFromJSON(json['outboundOrderStatisticsInfoVO']),
        'outboundCancelOrderStatisticsInfoVO': json['outboundCancelOrderStatisticsInfoVO'] == null ? undefined : KsosOrderStatisticsInfoVoFromJSON(json['outboundCancelOrderStatisticsInfoVO']),
        'returnOrderStatisticsInfoVO': json['returnOrderStatisticsInfoVO'] == null ? undefined : KsosOrderStatisticsInfoVoFromJSON(json['returnOrderStatisticsInfoVO']),
        'allOrderStatisticsInfoVO': json['allOrderStatisticsInfoVO'] == null ? undefined : KsosOrderStatisticsInfoVoFromJSON(json['allOrderStatisticsInfoVO']),
    };
}

export function KoreaStockOutboundOrderSkuStatisticsInfoVoToJSON(json: any): KoreaStockOutboundOrderSkuStatisticsInfoVo {
    return KoreaStockOutboundOrderSkuStatisticsInfoVoToJSONTyped(json, false);
}

export function KoreaStockOutboundOrderSkuStatisticsInfoVoToJSONTyped(value?: KoreaStockOutboundOrderSkuStatisticsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuCode': value['skuCode'],
        'skuId': value['skuId'],
        'imageUrl': value['imageUrl'],
        'color': value['color'],
        'size': value['size'],
        'name': value['name'],
        'processingOrderStatisticsInfoVO': KsosOrderStatisticsInfoVoToJSON(value['processingOrderStatisticsInfoVO']),
        'outboundOrderStatisticsInfoVO': KsosOrderStatisticsInfoVoToJSON(value['outboundOrderStatisticsInfoVO']),
        'outboundCancelOrderStatisticsInfoVO': KsosOrderStatisticsInfoVoToJSON(value['outboundCancelOrderStatisticsInfoVO']),
        'returnOrderStatisticsInfoVO': KsosOrderStatisticsInfoVoToJSON(value['returnOrderStatisticsInfoVO']),
        'allOrderStatisticsInfoVO': KsosOrderStatisticsInfoVoToJSON(value['allOrderStatisticsInfoVO']),
    };
}

